import { useState, useEffect } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { FunctionsHttpError } from '@supabase/supabase-js'
import { Button, Typography, Card } from "antd";
import "antd/dist/reset.css";
import "../../App.css";
import { useAuth } from "../AuthProvider";
import { showToast } from "../../utils/toast";
import CustomLoader from "../Common/CustomLoader";
import AddPriceDialog from "../Common/AddPriceDialog";

const { Title, Text } = Typography;

const QRScanner: React.FC = () => {
  const { supabase } = useAuth();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [scannedResult, setScannedResult] = useState<string | null>(null);
  const [scanner, setScanner] = useState<Html5QrcodeScanner | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [scanDisabled, setScanDisabled] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [seriesName, setSeriesName] = useState<string>('');

  // Detect if device is mobile
  // useEffect(() => {
  //   const checkIsMobile = () => {
  //     return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  //   };
    
  //   setIsMobile(checkIsMobile());
  // }, []);

  // Function to call Supabase Edge Function
  const updateSalesData = async (tagInfo: string, price: Number) => {
    setLoading(true);
    setError(null);

    const payload = {
      qr_tag: tagInfo,
      price
    };

    try {
      const { data, error } = await supabase.functions.invoke("sale", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      console.log('salesData =', data, ' salesError-', error, ' series anme=', data?.data?.series_number);
      if (error) {
        throw error;
      }
      setSeriesName(data?.data?.series_number);
      showToast('success', "QR scanned successful!!!");
    } catch (error: any) {
      console.log('err msg catch =', error)
      setLoading(false);
      if (error && error instanceof FunctionsHttpError) {
        const errorMessage = await error?.context?.json()
        console.log('Function returned an error', errorMessage)
        showToast('error', errorMessage?.error || "Error in QR code, please scan right QR code again");
      } else {
        showToast('error', error?.message || "Error in QR code, please scan right QR code again");
      }
    } finally {
      setLoading(false);
    }
  };

  const startScanner = () => {
    setScanDisabled(true);
    const newScanner = new Html5QrcodeScanner("qr-reader", {
      fps: 10,
      qrbox: { width: 500, height: 500 },
      // supportedScanTypes: isMobile ? [Html5QrcodeScanType.SCAN_TYPE_CAMERA] : [
      //   Html5QrcodeScanType.SCAN_TYPE_CAMERA,
      //   Html5QrcodeScanType.SCAN_TYPE_FILE]
    }, false);

    newScanner.render(
      (decodedText: string) => {
        const qrId = decodedText.substring(decodedText.lastIndexOf("/") + 1);
        setScannedResult(qrId);
        // display modal
        setIsModalVisible(true);
        // updateSalesData(qrId);
        // newScanner.clear();
        // setScanner(null);
      },
      (error) => console.log(error)
    );

    setScanner(newScanner);
  };

  const clearScanData = () => {
    setScannedResult(null);
    setScanDisabled(false);
  };

  const onHideModal = () => {
    setIsModalVisible(false);
    setScannedResult(null);
    setScanDisabled(false);
  }

  const onConfirm = (price: Number) => {
    setIsModalVisible(false);
    updateSalesData(scannedResult || '', price);
    scanner?.clear();
    setScanner(null);
  }

  return (
    <div className="flex max-h-screen items-center justify-center bg-gray-100 px-4 w-full overflow-y-hidden">
      {loading && (
        <CustomLoader />
      )}
      <Card className="!p-3">
        <div className="flex flex-col items-center">
          <div className="!flex !w-full !justify-center !items-center !text-center text-xl md:text-2xl">Sales QR Code Scanner</div>
          {!scannedResult ? (
            !scanDisabled && <Button type="primary" disabled={scanDisabled} onClick={startScanner} className="landing-whatsapp-btn flex justify-center items-center !mt-10">
              Scan QR Code
            </Button>
          ) : (
            <div className="flex flex-col items-center justify-center">
              {seriesName && <Text strong className="result mb-2">
                QR Series Name: {seriesName || '...'}
              </Text>}
              <Text strong className="result mb-4">
                Scanned Result: {scannedResult}
              </Text>
              <Button type="primary" onClick={clearScanData} className="landing-whatsapp-btn mt-4">
                Back To Scan
              </Button>
            </div>
          )}
          <div id="qr-reader" className="mt-5"></div>
        </div>
      </Card>
      {isModalVisible &&
        <AddPriceDialog
          onCancel={onHideModal}
          onConfirm={onConfirm}
          isModalVisible={isModalVisible}
        />
      }
    </div>
  );
};

export default QRScanner;
